// ink-component
import React, { ReactNode } from 'react';
import { StyledComponentPropsWithAs } from 'babel-plugin-styled-components';
import getGlobalProps from '../../../helpers/constants/global-props';
import CustomText from '../CustomText/CustomText';

export interface TextProps extends StyledComponentPropsWithAs {
  /** A **textual** HTML tag to be used when rendering the text node, like 'p', 'h6' or 'small' for example. */
  as?: string;
  /** Horizontal alignment of the text inside `children` */
  align?: 'inherit' | 'left' | 'center' | 'right';
  /** Removes the white space below the heading */
  trim?: boolean;
  /** Content */
  children?: ReactNode;
  /** Hierarchy variant */
  variant?:
    | 'body-1'
    | 'body-2'
    | 'body-3'
    | 'body-3-feedback-neutral'
    | 'body-3-feedback-positive'
    | 'body-3-feedback-negative'
    | 'small-1'
    | 'small-2'
    | 'display-1'
    | 'display-1-feedback-positive'
    | 'display-1-feedback-negative'
    | 'display-2'
    | 'display-2-feedback-positive'
    | 'display-2-feedback-negative'
    | 'monospace';
  /** Allows control over text wrapping */
  whiteSpace?: 'inherit' | 'normal' | 'nowrap';
  /** @ignore */
  'aria-level'?: string | number;
}

/**
 * @purpose Format and structure body copy for readability
 * @group Typography
 * @categories typography
 */
function Text(props: TextProps) {
  const globalProps = getGlobalProps({
    sunset: props['data-ink-sunset'],
  });

  return (
    <CustomText {...props} {...globalProps}>
      {props.children}
    </CustomText>
  );
}

Text.defaultProps = {
  align: 'inherit',
  trim: false,
  variant: 'body-3',
  whiteSpace: 'inherit',
};

Text.displayName = 'Text';

export default Text;
